import {
  LOADING_STATUS,
  SENSOR_TYPES,
  TRACKING
} from 'common/constants/constants';
import { LINE_HEIGHT, SPACES } from 'common/constants/sizes';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import TermsAndPolicy from 'components/TermsAndPolicy';
import { getMatchingProviders } from './link-account-modal.service';
import {
  linkAccount,
  getLinkAccountToken
} from '../AuthModals/auth.modals.service';
import LinkAccountErrorHandler from './LinkAccountErrorHandler';
import { useGetConnectedSensors } from './useGetConnectedSensors';
import { ProviderBoxesView } from '../LoginModal/components';

const LinkAccountModal = () => {
  const { data, error, status } = useGetConnectedSensors({
    token: getLinkAccountToken(),
    sensorTypeId: SENSOR_TYPES.GIT
  });

  const providers = getMatchingProviders(data);

  const getContent = () => (
    <>
      <Text
        size='medium'
        lineHeight={LINE_HEIGHT.medium}
        width='25rem'
        align='center'
      >
        We empower you to make great decisions by correlating Git and project
        data to highlight issues that need your attention
      </Text>
      {data.length > 1 ? (
        <Text size='x-large' pt={SPACES['x-x-large']} color='shuttleGray'>
          So, which Git provider are you most active on?
        </Text>
      ) : (
        <Text size='x-large' pt={SPACES['x-x-large']} color='shuttleGray'>
          Connect with your Git provider:
        </Text>
      )}

      <ProviderBoxesView
        providers={providers}
        onProviderClick={provider =>
          linkAccount(`${provider.authIdentity}_identity`)
        }
      />

      <Text
        color='gray'
        pt={SPACES['x-x-large']}
        align='center'
        lineHeight={LINE_HEIGHT['normal']}
      >
        By continuing, you agree to our
      </Text>
      <TermsAndPolicy
        page={TRACKING.PAGES.ONBOARDING}
        page_tab={TRACKING.PAGE_TABS.SIGN_UP}
      />
    </>
  );

  return (
    <Flex direction='column' height='100%'>
      <Flex direction='column' items='center' grow='1' pr='medium' pl='medium'>
        <Text
          size='x-x-x-large'
          weight='300'
          pt={SPACES.big}
          pb={SPACES.small}
          color='black'
        >
          Welcome to LinearB
        </Text>
        {error || (status === LOADING_STATUS.COMPLETED && !data.length) ? (
          <LinkAccountErrorHandler error={error} />
        ) : (
          getContent()
        )}
      </Flex>
    </Flex>
  );
};

export default LinkAccountModal;
